import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['radiusAndShadow'] = {
  boxShadow: themeUi.core.shadow.shadow200,
  backgroundColor: themeUi.semantic.color.background.neutral100
};

export default theme;
